import { HttpResponse, delay, http } from 'msw';

import {
  getCustomHandlerLoginStatus,
  getCustomHandlerMembership,
  getCustomHandlerRegisterPlatformStatus,
} from './utils';
import { MOCK_DELAY } from './utils/constants';

export const getCustomPlatformGetCurrentLocalUserMockHandler = () => {
  return http.get('*/user/local', async () => {
    await delay(MOCK_DELAY);

    if (!getCustomHandlerLoginStatus()) {
      return new HttpResponse(null, { status: 401 });
    }

    const attachValidHeader = getCustomHandlerRegisterPlatformStatus();

    const membership = getCustomHandlerMembership();

    return HttpResponse.json(
      {
        created_at: '2024-11-20T12:24:21.482367Z',
        email: 'admin@localhost',
        enabled: true,
        id: 'f846b3a1-6fc0-4dac-a6d4-b9d8e1244eb4',
        is_admin: true,
        last_login_at: '2024-12-05T11:49:33.477586Z',
        name: 'CloudQuery Admin',
        profile_image_url: '',
        teams: [membership],
        updated_at: '2024-11-20T12:24:21.482367Z',
      },
      {
        headers: attachValidHeader ? { 'X-Cq-Activation-Valid': 'true' } : {},
        status: 200,
      },
    );
  });
};
